import { colorScheme } from "./color-scheme";

import { markByName, markByType } from "../common/mark";

import { token } from "../../token";

import { poptip } from "../common/component/poptip";

export const lightTheme = {
    name: "light",
    background: {
        type: "palette",
        key: "backgroundColor"
    },
    padding: 20,
    fontFamily: {
        type: "token",
        key: "fontFamily"
    },
    colorScheme: colorScheme,
    token: token,
    component: {
        poptip: poptip
    },
    mark: markByType,
    markByName: markByName,
    animationThreshold: 2e3
};
//# sourceMappingURL=index.js.map
